"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@headlessui/react");
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const elements_ui_icon_1 = __importStar(require("@hydrogen/elements.ui.icon"));
const solid_1 = require("@heroicons/react/solid");
const react_2 = __importDefault(require("react"));
const LinkMore = ({ children = null, hasActive = false, origin, }) => (react_2.default.createElement(react_1.Menu, { as: "span", className: "flex-shrink-0 relative inline-block text-start" }, ({ open }) => (react_2.default.createElement(react_2.default.Fragment, null,
    react_2.default.createElement(react_1.Menu.Button, { className: (0, elements_ui_utils_1.classNames)(hasActive
            ? 'bg-button-header-background text-header-text-hover-active'
            : 'text-header-text hover:bg-button-header-background hover:text-header-text-hover-active', 'rounded-button text-center px-2.5 py-1.5 text-sm font-semibold', elements_ui_utils_1.globalColorClasses.focus, open ? 'bg-misc-100' : '') },
        react_2.default.createElement(elements_ui_icon_1.default, { icon: solid_1.DotsHorizontalIcon, size: elements_ui_icon_1.IconsSizes.default })),
    react_2.default.createElement(elements_ui_utils_1.TransitionHelper, { origin: origin },
        react_2.default.createElement(react_1.Menu.Items, null, children))))));
exports.default = LinkMore;
//# sourceMappingURL=LinkMore.js.map